module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-images"
    }
  }, [(!_vm.isEditing) ? _c('section', {
    staticClass: "top-only"
  }, [(_vm.images.length) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['lbl_preview']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_page']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_location']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_size']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_on']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_off']))]), _c('th')])]), _c('tbody', _vm._l((_vm.images), function(image, index) {
    return _c('tr', {
      key: index,
      staticClass: "is-64"
    }, [_c('td', [(_vm.canShow(image)) ? _c('p', {
      staticClass: "image is-64x64 preview",
      style: (_vm.getCSSBackgroundImage(image))
    }) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.getImageName(image)))]), _c('td', [_vm._v(_vm._s(_vm.getImagePage(image)))]), _c('td', [_vm._v(_vm._s(_vm.getImageLocation(image)))]), _c('td', [_vm._v(_vm._s(_vm.tokens['lbl_keep_size'](image.keepOriginalSize)))]), _c('td', [_c('div', {
      staticClass: "event-name"
    }, [_vm._v(_vm._s(_vm.formatEventName(image.on)))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasParameters(image.on)),
        expression: "hasParameters( image.on )"
      }],
      staticClass: "event-param"
    }, [_vm._v(_vm._s(_vm.formatEventParams(image.on)))])]), _c('td', [_c('div', {
      staticClass: "event-name"
    }, [_vm._v(_vm._s(_vm.formatEventName(image.off)))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasParameters(image.off)),
        expression: "hasParameters( image.off )"
      }],
      staticClass: "event-param"
    }, [_vm._v(_vm._s(_vm.formatEventParams(image.off)))])]), _c('td', [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_params']
      },
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })])]), _c('td', [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_remove']
      },
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _c('section', [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_images']))])])]) : _vm._e(), _c('section', {
    staticClass: "absolute-parent"
  }, [(!_vm.isEditing) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('section', {
    staticClass: "is-fullwidth is-dropzone",
    class: {
      'is-dragover': _vm.isDraggingFileOverDropzone
    },
    on: {
      "drag": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "dragstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragend": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragleave": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = true
      },
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = true
      },
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.dropFile($event)
      }
    }
  }, [_c('div', {
    staticClass: "file is-centered is-boxed"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.selectFile($event)
      }
    }
  }), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(0), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.tokens['msg_choose']))]), _c('span', {
    staticClass: "help"
  }, [_vm._v(_vm._s(_vm.tokens['msg_drag']))])])])])])]) : _vm._e(), (_vm.selectedFile || _vm.isEditing) ? _c('div', {
    class: {
      'sticked': !_vm.isEditing, 'at-top': !_vm.images.length, 'at-bottom': _vm.images.length
    }
  }, [(_vm.selectedFile) ? _c('article', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageURL(_vm.selectedFile)
    }
  })])]), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.selectedFile.name))])]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.selectedFile.size) + " " + _vm._s(_vm.tokens['lbl_bytes']))])]), _c('progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    staticClass: "progress is-small is-primary",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.uploadProgress
    }
  })])]), _c('div', {
    staticClass: "media-right"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.isUploading || !_vm.hasValidParams
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_upload']))]), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])]) : _vm._e(), _c('article', [(_vm.isEditing) ? _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }), _c('div', {
    staticClass: "field-body"
  }, [_c('h4', {
    staticClass: "heading is-4"
  }, [_vm._v(_vm._s(_vm.getImageName(_vm.images[_vm.editingImageIndex])))])])]) : _vm._e(), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_page']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_any']))]), _vm._l((_vm.pageCount), function(index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index - 1
      }
    }, [_vm._v(_vm._s(index))])
  })], 2)])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_location']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.offset),
      expression: "offset",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input is-inline",
    attrs: {
      "type": "number",
      "step": "5",
      "min": "0",
      "max": "800"
    },
    domProps: {
      "value": (_vm.offset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.offset = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "info-label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_pixels']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_left']))]), _c('option', {
    attrs: {
      "value": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_bottom']))]), _c('option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_right']))])])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_size']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepOriginalSize),
      expression: "keepOriginalSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.keepOriginalSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_original']))]), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_15']))])])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_show']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.on),
      expression: "on"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.on = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ON), function(text, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(text))])
  }))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.on === 'fixation'),
      expression: "on === 'fixation'"
    }],
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_at']))]), _c('div', {
    staticClass: "field-body select-container"
  }, [_c('div', {
    staticClass: "select is-multiple"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixationWords),
      expression: "fixationWords"
    }],
    attrs: {
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fixationWords = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.currentWords), function(word) {
    return _c('option', {
      key: word.text + Math.random(),
      domProps: {
        "value": word
      }
    }, [_vm._v(_vm._s(word.text))])
  }))])]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_longer']))]), _c('div', {
    staticClass: "field-body number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixationDuration),
      expression: "fixationDuration"
    }],
    staticClass: "input is-number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fixationDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fixationDuration = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v("ms")])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_hide']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.off),
      expression: "off"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.off = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.OFF), function(text, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(text))])
  }))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.off === 'delay'),
      expression: "off === 'delay'"
    }],
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delayDuration),
      expression: "delayDuration"
    }],
    staticClass: "input is-number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.delayDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delayDuration = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v("sec")])])])]), (_vm.isEditing) ? _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "is-grouped is-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveEdited()
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['save']))]), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.cancelEditing()
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])]) : _vm._e()])]) : _vm._e()]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65010d36"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/taskEditorImages.vue
// module id = 430
// module chunks = 0